import { Typography } from "antd";
import { useTranslation } from "react-i18next";

/** Modal helper text shown when promoting/demoting a team member. */
export const RoleCapabilitiesHelp = () => {
  const { t } = useTranslation();
  return (
    <ul>
      <li>
        <Typography.Text strong>{t("team.roles.ADMIN")}</Typography.Text>: {t("team.roleCapabilitiesAdmin")}
      </li>
      <li>
        <Typography.Text strong>{t("team.roles.MEMBER")}</Typography.Text>: {t("team.roleCapabilitiesMember")}
      </li>
    </ul>
  );
};
